import spinner from "assets/images/Spinner-V2.svg";
import apiSpinner from "assets/images/v2/spinner-vista-blue.svg";
import "./spinner.scss";


export const Spinner = ({isApi = false}: {isApi?: boolean}) => {
  let spinnerClass = "spinner";
  if (isApi) {
    spinnerClass += " spinner-api";
  }

  return (
    <div className={spinnerClass}>
      <img src={isApi ? apiSpinner : spinner} alt="loading" className="spinner-img" />
    </div>
  );
};
